import {detect} from "detect-browser";

const browser = detect();

const isSafari =
  (browser && browser.name === "safari") || (browser && browser.name === "ios");

export {isSafari, browser};
